import { FC } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import theme from "@/theme";
import { styles } from "../stylesSignUp";
import HeaderControl from "./HeaderControl";

const SuccessCheckIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      stroke="#00A63E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 24L22 28L30 20"
      stroke="#00A63E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface WaitlistSuccessProps {
  setSignUpStep: React.Dispatch<React.SetStateAction<number>>;
  email: string;
}

const WaitlistSuccess: FC<WaitlistSuccessProps> = ({ setSignUpStep, email }) => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.wrapper}>
      <HeaderControl onClick={() => setSignUpStep(5)} logo />

      <Box
        sx={{
          marginTop: "40px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "14px",
        }}
      >
        <SuccessCheckIcon />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "center" }}>
          <Typography
            component="h1"
            variant="h2"
            fontFamily="Inter"
            lineHeight="26px"
            fontSize="22px"
            fontWeight={600}
            textAlign="center"
            color={theme.palette.custom.mainBlack}
          >
            You're on the list!
          </Typography>

          <Typography
            variant="h4"
            fontFamily="Inter"
            lineHeight="22px"
            fontSize="16px"
            fontWeight={500}
            textAlign="center"
            sx={{ color: "#7D8690" }}
          >
            We've added{" "}
            <Box component="span" sx={{ fontWeight: 600, color: "#383C40" }}>
              {email}
            </Box>{" "}
            to our waitlist. We'll send you an invite as soon as a spot opens up.
          </Typography>
        </Box>
      </Box>

      <Button
        fullWidth
        variant="contained"
        onClick={() => navigate("/login")}
        sx={{ ...styles.inviteButton, marginTop: "32px" }}
      >
        Back to sign in
      </Button>
    </Box>
  );
};

export default WaitlistSuccess;
